import { datadogRum } from "@datadog/browser-rum";
import { useClientEnv } from "@magalu/rave/config";
import { useEffect, ReactNode } from "react";

import { getAppVersion } from "@utils/getAppVersion";

export type ClientEnvType = {
  datadog: {
    dataDogEnable: boolean;
    dataDogEnv: "production" | undefined;
    dataDogSessionRate: number;
    dataDogSessionReplay: number;
  };
};

export type DataDogRumProps = {
  children: ReactNode;
};

const DataDogRum = ({ children }: DataDogRumProps) => {
  const {
    client: {
      datadog: {
        dataDogEnable,
        dataDogEnv,
        dataDogSessionRate,
        dataDogSessionReplay,
      },
    },
  } = useClientEnv() as { client: ClientEnvType };
  const appVersion = getAppVersion();

  useEffect(() => {
    if (!dataDogEnable || !!datadogRum.getInitConfiguration()) {
      return;
    }

    datadogRum.init({
      applicationId: "d2d4fb67-671c-4741-a22e-b64208ef8e6b",
      clientToken: "pub9efdddc6a25a401db9b203ca95a1cbf9",
      defaultPrivacyLevel: "mask-user-input",
      env: dataDogEnv,
      service: "imperio",
      sessionReplaySampleRate: dataDogSessionReplay,
      sessionSampleRate: dataDogSessionRate,
      site: "datadoghq.com",
      version: `v${appVersion}`,
    });
  }, []);

  return <>{children}</>;
};

export default DataDogRum;
